var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { EthersLiquity, ReadableEthersLiquity } from '@sovryn-zero/lib-ethers';
import { getProvider } from '@sovryn/ethers-provider';
import { getRskChainId } from '../../utils/chain';
export const useGetRBTCPrice = () => {
    const [price, setPrice] = useState('0');
    useEffect(() => {
        const getPrice = () => __awaiter(void 0, void 0, void 0, function* () {
            const provider = yield ReadableEthersLiquity.connect(getProvider(getRskChainId()), { useStore: 'blockPolled' });
            const liquity = new EthersLiquity(provider);
            const price = yield liquity.getPrice();
            return price.toString();
        });
        getPrice().then(setPrice);
    }, [price]);
    return { price };
};
